import { axiosClient, axiosClientAuth } from '../../../utils/axiosClient'
import { PermissionsResponse } from './_models'

export const LOGIN_URL = '/auth/login/'
export const LOGIN_VERIFY_URL = '/auth/verify-otp/'
export const REGISTER_URL = '/register'
export const REQUEST_PASSWORD_URL = '/forgot_password'
export const AUTH_PERMISSIONS_URL = '/auth/permissions/'
export const RBAC_PERMISSIONS_URL = '/auth/rbac-permissions/'
export const PROFILE_URL = '/auth/profile/'
// Server should return AuthModel
export function login(identifier: string) {
  return axiosClient.post(LOGIN_URL, { identifier })
}

export function resendOtp(identifier: string) {
  return axiosClient.post(LOGIN_URL, { identifier })
}

// Server should return AuthModel
export function loginVerify(identifier: string, otp: string) {
  return axiosClient.post(LOGIN_VERIFY_URL, { identifier, otp }).then((response) => {
    const normalizedData = {
      ...response.data,
      data: {
        ...response.data.data,
        access_token: response.data?.data?.access,
      },
    }

    return {
      ...response,
      data: normalizedData,
    }
  })
}

export function getAuthPermissions() {
  return axiosClientAuth.get<PermissionsResponse>(AUTH_PERMISSIONS_URL)
}

export function getRbacPermissions() {
  return axiosClientAuth.get(RBAC_PERMISSIONS_URL, { params: { page_size: 100 } })
}

export function getProfile() {
  return axiosClientAuth.get(PROFILE_URL)
}

// Server should return AuthModel
export function register(
  email: string,
  firstname: string,
  lastname: string,
  password: string,
  password_confirmation: string
) {
  return axiosClient.post(REGISTER_URL, {
    email,
    first_name: firstname,
    last_name: lastname,
    password,
    password_confirmation,
  })
}

// Server should return object => { result: boolean } (Is Email in DB)
export function requestPassword(email: string) {
  return axiosClient.post<{ result: boolean }>(REQUEST_PASSWORD_URL, {
    email,
  })
}
